
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TextAreaFieldComponent } from '../../../../../components/form/textarea-field/textarea-field.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { RegulationsService } from '../../../../../services/api/general-settings/regulations.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { JurisdictionsService } from 'src/app/services/api/general-settings/jurisdictions.service';

@Component({
  selector: 'translations-details',
  imports: [TextAreaFieldComponent, ReactiveFormsModule, NgbAlert],
  templateUrl: './translations-details.component.html',
  styleUrl: './translations-details.component.scss'
})
export class TranslationsDetailsComponent {
  @Input() translations?: any;
  @Input() readonlyTranslationsDetails: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();


  languages:{ code: string; flag: string; label:string }[] = [];

  activeTab: string = 'eng';
  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };
 constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private regulationsService: RegulationsService,
    private jurisdictionsService: JurisdictionsService
  ){}
  ngOnInit(): void {
    this.form = new FormGroup({
      eng: new FormControl('', [Validators.required]),
      ita: new FormControl('', [Validators.required]),
      spa: new FormControl('', [Validators.required]),
    });
   setTimeout(() => {
    if (this.translations) {
     this.languages = this.translations?.map((lang: any) => ({
      code: lang.language.iso3,
      flag: `/assets/flags/${lang.language.iso2}.svg`,
      label: lang.language.name,
    }));
  } else {
    this.jurisdictionsService.languages().subscribe((languages: any) => {
      console.log('languages', languages);
      
     this.languages = languages.data.featureLanguages.map((lang: any) => ({
       code: lang.language.iso3,
       flag: `/assets/flags/${lang.language.iso2}.svg`,
       label: lang.language.name,
     }));
   });
  }
   }, 300);

   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['translations'] && changes['translations'].currentValue) {
      console.log('changes', changes['translations'].currentValue);
      this.languages = changes['translations'].currentValue.map((lang: any) => ({
        code: lang.language.iso3,
        flag: `/assets/flags/${lang.language.iso2}.svg`,
        label: lang.language.name,
      }));
      const translationsMap: {[key: string]: string} = {};
      changes['translations'].currentValue.forEach((translation: any) => {
        const languageCode = translation.language.iso3;
        translationsMap[languageCode] = translation.article;
      });
      this.form.patchValue({
        eng: translationsMap['eng'] || '',
        ita: translationsMap['ita'] || '',
        spa: translationsMap['spa'] || '',
      });
    }
  }

  /**
     * *******************
     * Submit form methods
     * *******************
     */  
    
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {
    
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.translations ? this.regulationsService.update(this.translations.id, values) : this.regulationsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  getTranslationsEngInput(): FormControl { return this.getFormControl('eng'); }
  getTranslationsItaInput(): FormControl { return this.getFormControl('ita'); }
  getTranslationsSpaInput(): FormControl { return this.getFormControl('spa'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
